export default __webpack_public_path__ + "static/media/Schmidt1.ee055b56.png";